module.exports = __webpack_public_path__ + "static/fonts/Spoqa-Han-Sans-Light.8eaaae7.ttf";